'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var React = require("react");
var RemoteData = require("remotedata-re/src/RemoteData.bs.js");
var Belt_Result = require("bs-platform/lib/js/belt_Result.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

var RemoteData$1 = RemoteData;

function handleAPICallError(promise) {
  return promise.then(function (r) {
                if (r.ok || r.status === 404) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: r
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: "API call failed: " + r.statusText
                            });
                }
              }).catch(function (err) {
              console.log("APICallError", err);
              return Promise.resolve({
                          TAG: /* Error */1,
                          _0: "Network Error"
                        });
            });
}

function extractJson(promise) {
  return promise.then(function (result) {
              if (result.TAG === /* Ok */0) {
                return result._0.json().then(function (decoded) {
                              return Promise.resolve({
                                          TAG: /* Ok */0,
                                          _0: Caml_option.some(decoded)
                                        });
                            }).catch(function (param) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: undefined
                                      });
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
            });
}

function get(url) {
  return extractJson(handleAPICallError(fetch(url)));
}

function postOrPut(verb, url, body) {
  var headers = {
    Accept: "*",
    "Content-Type": "application/json"
  };
  var req = body !== undefined ? Fetch.RequestInit.make(verb, Caml_option.some(headers), Caml_option.some(JSON.stringify(Caml_option.valFromOption(body))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined) : Fetch.RequestInit.make(verb, Caml_option.some(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return extractJson(handleAPICallError(fetch(url, req)));
}

function put(param, param$1) {
  return postOrPut(/* Put */3, param, param$1);
}

function post(param, param$1) {
  return postOrPut(/* Post */2, param, param$1);
}

function $$delete(url) {
  var req = Fetch.RequestInit.make(/* Delete */4, {
          Accept: "*"
        }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
  return handleAPICallError(fetch(url, req)).then(function (res) {
              return Promise.resolve(Belt_Result.flatMap(res, (function (param) {
                                return {
                                        TAG: /* Ok */0,
                                        _0: undefined
                                      };
                              })));
            });
}

var BsFetch = {
  get: get,
  post: post,
  put: put,
  $$delete: $$delete
};

function note(o, e) {
  if (o !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: Caml_option.valFromOption(o)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: e
          };
  }
}

function deccoErrorToResponse(r) {
  if (r.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: r._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: r._0.message
          };
  }
}

function toLoading(data) {
  return {
          TAG: /* Loading */0,
          _0: RemoteData.withDefault(undefined, RemoteData.map((function (d) {
                      return Caml_option.some(d);
                    }), data))
        };
}

function updateRemoteData(data, action) {
  if (typeof action === "number") {
    return toLoading(data);
  } else if (action.TAG === /* NetworkRequestSuccess */0) {
    return {
            TAG: /* Success */2,
            _0: action._0
          };
  } else {
    return {
            TAG: /* Failure */1,
            _0: action._0
          };
  }
}

function responseToAction(response) {
  if (response.TAG === /* Ok */0) {
    return {
            TAG: /* NetworkRequestSuccess */0,
            _0: response._0
          };
  } else {
    return {
            TAG: /* NetworkRequestError */1,
            _0: response._0
          };
  }
}

function getWhenNeeded(state, dispatch, param) {
  if (typeof state === "number") {
    Curry._1(dispatch, undefined);
  }
  
}

function Hook(CLIENT) {
  var get = function (url, decode, dispatch) {
    Curry._1(dispatch, /* NetworkRequestBegin */0);
    return Curry._1(CLIENT.get, url).then(function (result) {
                var tmp;
                tmp = result.TAG === /* Ok */0 ? responseToAction(Belt_Result.flatMap(note(result._0, "Need json"), (function (json) {
                              return deccoErrorToResponse(Curry._1(decode, json));
                            }))) : ({
                      TAG: /* NetworkRequestError */1,
                      _0: result._0
                    });
                return Promise.resolve(Curry._1(dispatch, tmp));
              });
  };
  var putOrPost = function (action, decode, dispatch) {
    Curry._1(dispatch, /* NetworkRequestBegin */0);
    return Curry._1(action, undefined).then(function (resp) {
                var tmp;
                tmp = resp.TAG === /* Ok */0 ? ({
                      TAG: /* Ok */0,
                      _0: Curry._1(dispatch, responseToAction(Belt_Result.flatMap(note(resp._0, "Missing expected JSON from the response!"), (function (json) {
                                      return deccoErrorToResponse(Curry._1(decode, json));
                                    }))))
                    }) : ({
                      TAG: /* Error */1,
                      _0: Curry._1(dispatch, {
                            TAG: /* NetworkRequestError */1,
                            _0: resp._0
                          })
                    });
                return Promise.resolve(tmp);
              });
  };
  var post = function (url, data) {
    return function (param, param$1) {
      return putOrPost((function (param) {
                    return Curry._2(CLIENT.post, url, data);
                  }), param, param$1);
    };
  };
  var useGet = function (url, decoder) {
    var match = React.useState(function () {
          return /* NotAsked */0;
        });
    var setState = match[1];
    var state = match[0];
    var dispatch = function (param) {
      get(url, decoder, (function (r) {
              var s = updateRemoteData(state, r);
              return Curry._1(setState, (function (_prevState) {
                            return s;
                          }));
            }));
      
    };
    return [
            state,
            dispatch
          ];
  };
  var useAutoGet = function (url, decoder) {
    var match = useGet(url, decoder);
    var dispatch = match[1];
    React.useEffect((function () {
            Curry._1(dispatch, undefined);
            
          }), [url]);
    return match[0];
  };
  var usePost = function (url, encoder, decoder) {
    var match = React.useState(function () {
          return /* NotAsked */0;
        });
    var setState = match[1];
    var state = match[0];
    var dispatch = function (data) {
      post(url, Caml_option.some(Curry._1(encoder, data)))(decoder, (function (r) {
              var s = updateRemoteData(state, r);
              return Curry._1(setState, (function (_prevState) {
                            return s;
                          }));
            }));
      
    };
    return [
            state,
            dispatch
          ];
  };
  return {
          get: get,
          putOrPost: putOrPost,
          post: post,
          useGet: useGet,
          useAutoGet: useAutoGet,
          usePost: usePost
        };
}

exports.RemoteData = RemoteData$1;
exports.BsFetch = BsFetch;
exports.note = note;
exports.deccoErrorToResponse = deccoErrorToResponse;
exports.toLoading = toLoading;
exports.updateRemoteData = updateRemoteData;
exports.responseToAction = responseToAction;
exports.getWhenNeeded = getWhenNeeded;
exports.Hook = Hook;
/* react Not a pure module */
